import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text, View } from "react-native";

import { connect } from "react-redux";
import DoctorAvatarWithDetail from "./DoctorAvatarWithDetail";
import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class TimelineItem extends React.Component {
  static propTypes = {
    createdAt: PropTypes.instanceOf(Date).isRequired,
    doctor: PropTypes.shape({
      avatarUrl: PropTypes.string,
      fullName: PropTypes.string.isRequired,
      specialities: PropTypes.string.isRequired,
    }).isRequired,
    summary: PropTypes.string.isRequired,
    patientName: PropTypes.string.isRequired,
    transactionDependency: PropTypes.object,
    dependentStatus: PropTypes.number,
    dependent: PropTypes.string,
  };

  render() {
    const {
      createdAt,
      dependent,
      dependentStatus,
      doctor,
      patientName,
      summary,
      themeColors,
      transactionDependency,
    } = this.props;

    return (
      <>
        <Text
          style={[
            styles.createdAt,
            {
              color: themeColors.darkestPrimary,
            },
          ]}
        >
          {I18n.l("time.prixa.default", createdAt)}
        </Text>
        <DoctorAvatarWithDetail
          avatarUrl={doctor.avatarUrl}
          fullName={doctor.fullName}
          specialities={doctor.specialities}
        />
        <View style={{ marginTop: 16 }}>
          <Text>{I18n.t("prixa.consultationFor")}</Text>
          {!!transactionDependency || !!dependentStatus ? (
            <Text style={styles.patient}>
              {dependentStatus
                ? dependent
                : `${transactionDependency.first_name} ${transactionDependency.last_name}`}
            </Text>
          ) : (
            <Text style={styles.patient}>{patientName}</Text>
          )}
        </View>
        <Text style={styles.summary}>{summary}</Text>
      </>
    );
  }
}

const styles = StyleSheet.create({
  createdAt: {
    fontSize: 16,
    marginBottom: 20,

    ...fonts.regular,
  },
  summary: {
    color: staticColors.grey,
    fontSize: 12,
    marginTop: 16,
    textAlign: "justify",

    ...fonts.regular,
  },
  patient: {
    fontSize: 14,
    marginTop: 4,
    textAlign: "justify",
    ...fonts.bold,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(TimelineItem);
